import { Menu, Tooltip } from '@mantine/core';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Link } from 'react-router-dom';
import { FORM_PAGE_PATH, REVISION_PAGE_PATH } from 'routes/paths';
import { IconEye } from '@tabler/icons-react';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the users who have the permission to view the revision.
 */
export default function ViewAction({ revision, kind }: RevisionSingleActionProps) {
  const link =
    revision.kind === 'revision'
      ? REVISION_PAGE_PATH.insert({ revisionId: revision.revisionId })
      : FORM_PAGE_PATH.insert({ revisionId: revision.revisionId });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Pozrieť" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" component={Link} to={link}>
          <IconEye />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" component={Link} to={link} leftIcon={<IconEye />} variant="secondary" w={188}>
        Pozrieť
      </Button>
    );
  }

  return (
    <Menu.Item component={Link} to={link} icon={<IconEye stroke="1.5" size={24} />} color="gray.8">
      Pozrieť
    </Menu.Item>
  );
}
